

function RandomInt(offset, maxInt){
    return Math.floor(Math.random() * maxInt) + offset;
}

export default RandomInt;